<template>
  <swiper
    v-if="sides.length > 1"
    ref="printSideSwiper"
    :options="swiperOptions"
    class="swiper-container"
    @slideChange="switchPrintSide"
    @next="next"
    @prev="prev"
  >
    <swiper-slide v-for="{ key: side } of sides" :key="side" />
    <div
      id="page"
      slot="pagination"
      class="swiper-pagination swiper-pagination-bullets"
    ></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { MUTATION_SET_PRINT_SIDE } from '../store/mutation-types';

export default {
  name: 'PrintSideSwiper',
  components: {
    Swiper,
    SwiperSlide
  },
  data: () => ({
    swiperOptions: {
      loop: true,
      pagination: {
        el: '#page',
        type: 'bullets'
      }
    }
  }),
  computed: {
    sides() {
      return Object.keys(this.$store.getters['product/images']);
    },
    swiper() {
      return this.$refs.printSideSwiper;
    }
  },
  methods: {
    next() {
      this.swiper.$swiper.slideNext();
    },
    prev() {
      this.swiper.$swiper.slidePrev();
    },
    switchPrintSide() {
      const index = this.swiper.$swiper.realIndex;
      const side = this.sides[index];
      this.$store.commit(MUTATION_SET_PRINT_SIDE, side);
    }
  }
};
</script>

<style scoped>
.swiper-container {
  @apply h-full w-full absolute;
}
.swiper-pagination {
  @apply pin-t mt-3;
}
</style>
